import { render, staticRenderFns } from "./ValuationsPage.vue?vue&type=template&id=652cc948&scoped=true&"
import script from "./ValuationsPage.vue?vue&type=script&lang=js&"
export * from "./ValuationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652cc948",
  null
  
)

export default component.exports